require('multiple-select');

function initCheckboxMultiSelect(){
  $('.jb-checkbox-multiselect').each(function(index, element) {
    const $element = $(element);
    const isInitiated = $element.attr('is-initiated');

    if (isInitiated) {
      return;
    }

    $element.attr('is-initiated', true);

    const prevElement = $element.prev('.temporary-select');
    if (prevElement[0]) prevElement[0].classList.add('d-none');

    const allSelectedLabel = $element.data('all-selected-label');
    const countSelectedLabel = $element.data('count-selected-label');
    const noMatchesFoundLabel = $element.data('no-matches-found-label');
    const classInput = $element.data('class-input');

    const options = {
      width: '100%',
    };

    const notifyChange = () => {
      dispatchNativeChange($element[0]);
    };

    options.onClick = notifyChange;
    options.onCheckAll = notifyChange;
    options.onUncheckAll = notifyChange;

    if (classInput) {
      options.classInput = classInput;
    }

    if (allSelectedLabel) {
      options.formatAllSelected = () => allSelectedLabel;
    }

    if (countSelectedLabel) {
      options.formatCountSelected = (count) => `${count} ${countSelectedLabel}`;
    }

    if (noMatchesFoundLabel) {
      options.formatNoMatchesFound = () => noMatchesFoundLabel;
    }

    $element.multipleSelect(options);
  });
}

function dispatchNativeChange(element) {
  const event = new Event('change', { bubbles: true });
  element.dispatchEvent(event);
}

$(function () {
  initCheckboxMultiSelect();

  document.addEventListener('jb.section.rendered', () => {
    initCheckboxMultiSelect();
  });

  document.addEventListener('section.initiated', () => {
    initCheckboxMultiSelect();
  });
});

